import React from 'react';
import CatalogueTopNav from '../new-service/CatalogueTopNav';
import useSites from './useSites';
import StockTransfers from './StockTransfers';
import '../gift-cards-v2/GiftCardsV2.css'; // StockTransfers draws on the v2 chrome
import './multiLocation.css';

/**
 * Catalogue → Transfers: move stock between locations. Lives with the rest
 * of stock (next to Stock Take) rather than under Settings, since it is a
 * day-to-day action, not a setting.
 */
export default function StockTransfersPage() {
  const { sites, active, multi, loading } = useSites();
  return (
    <div className="h_n _new__service catalogue-no-header">
      <div className="body_container cm_bg_white">
        <div className="catalogue-page-wrapper">
          <CatalogueTopNav />
          <div className="catalogue-content-container">
            <div className="catalogue-content-wrapper voucher-v2">
              <div className="v2-page-header">
                <div className="v2-page-title-row">
                  <h1 className="v2-page-title">Stock transfers</h1>
                </div>
                <p className="v2-page-sub">Move stock between your locations. It leaves here when you send it and arrives when the other location receives it.</p>
              </div>
              <div className="v2-page">
                {multi ? (
                  <StockTransfers sites={sites} active={active} />
                ) : loading ? (
                  <div className="v2-page-stub"><p className="v2-page-stub-sub">Loading…</p></div>
                ) : (
                  <div className="v2-page-stub"><p className="v2-page-stub-title">Add a second location to move stock</p><p className="v2-page-stub-sub">Transfers move products between the locations on this account.</p></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
